import SidePanel from 'components/Basic/SidePanel';
import Button from 'components/Basic/Button';
import ConfirmationModal from 'components/Basic/Modal/Confirmation';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { selectFlattenAreaState, selectTreeDoneLoading, selectIsFlattenAreaMode } from 'store/slices/TreeSlice/selector';
import FlattenAreaHeightField from './FlattenAreaHeightField';
import { TreeFieldGroup, TreePanelContent } from 'components/Tree/styles';
import { useEffect, useState } from 'react';
import { setDeleted, setSelectedShapeId } from 'store/slices/TreeSlice';
import useScreenDims from 'hooks/useScreenDims';
import { RIGHT_PANEL_MOBILE_BREAKPOINT } from '../../constants';

export default function FlattenAreaSidePanel() {
	const dispatch = useDispatch();
	const { editModeEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { treeEditingMode } = useSelector((state: RootState) => state.treeSlice.data);
	const { activePolygon } = useSelector(selectFlattenAreaState);
	const isFlattenAreaMode = useSelector(selectIsFlattenAreaMode);
	const isDoneLoading = useSelector(selectTreeDoneLoading);
	const [activeField, setActiveField] = useState<string | null>(null);
	// const [showConfirmClose, setShowConfirmClose] = useState(false);
	// const initialRef = useRef<{ id: ShapeId; height: number } | null>(null);
	const [showConfirmDelete, setShowConfirmDelete] = useState(false);
	const { width: screenWidth } = useScreenDims();
	const isMobileView = screenWidth <= RIGHT_PANEL_MOBILE_BREAKPOINT;

	const isOpen = editModeEnabled && treeEditingMode && isFlattenAreaMode && !!activePolygon;

	const closePanel = () => {
		dispatch(setSelectedShapeId(null));
	};

	const handleDone = () => {
		dispatch(setSelectedShapeId(null));
	};

	// useEffect(() => {
	// 	if (!isOpen || !activePolygon) {
	// 		initialRef.current = null;
	// 		return;
	// 	}
	// 	if (!initialRef.current || initialRef.current.id !== activePolygon.id) {
	// 		initialRef.current = {
	// 			id: activePolygon.id,
	// 			height: activePolygon.height ?? 0,
	// 		};
	// 	}
	// }, [activePolygon, isOpen]);

	// const hasEdits = () => {
	// 	if (!activePolygon || !initialRef.current) return false;
	// 	if (initialRef.current.id !== activePolygon.id) return false;
	// 	return heightDiff.hasChanges(
	// 		{ height: activePolygon.height ?? 0 },
	// 		{ height: initialRef.current.height }
	// 	);
	// };

	const handleClose = () => {
		// if (hasEdits()) {
		// 	setShowConfirmClose(true);
		// 	return;
		// }
		closePanel();
	};

	// const handleConfirmClose = () => {
	// 	if (initialRef.current && activePolygon && initialRef.current.id === activePolygon.id) {
	// 		dispatch(setFlattenHeight(initialRef.current.height));
	// 	}
	// 	setShowConfirmClose(false);
	// 	closePanel();
	// };

	const handleDelete = () => {
		if (!activePolygon) return;
		// setShowConfirmDelete(true);
		confirmDelete();
	};

	const confirmDelete = () => {
		if (!activePolygon) return;
		dispatch(setDeleted(activePolygon.id));
		dispatch(setSelectedShapeId(null));
		setShowConfirmDelete(false);
	};

	useEffect(() => {
		if (isOpen) {
			setActiveField(null);
		}
	}, [isOpen]);

	return (
		<>
			<SidePanel
				title="Flatten Area"
				open={isOpen}
				// onAction={handleDone}
				onClose={handleClose}
				closeBtnLabel="Done"
				closeBtnClassName="side-modal-close--primary"
				disableAction={!activePolygon}
				actionLoader={isDoneLoading}
				showActionBtn={false}
				position={isMobileView ? 'bottom' : 'right'}
				containerClassName={isMobileView ? 'side-panel-container--mobile' : undefined}
				panelClassName={isMobileView ? 'side-panel--mobile' : undefined}
				deleteBtn={
					<Button
						id="flatten-area-sidepanel-delete"
						type="button"
						className="sidepanel-delete"
						onClick={handleDelete}
						disabled={!activePolygon || isDoneLoading}
					>
						Delete
					</Button>
				}
			>
				{activePolygon ? (
					<TreePanelContent key={activePolygon.id}>
						<TreeFieldGroup>
							<FlattenAreaHeightField
								isActive={activeField === 'height'}
								onActivate={() => setActiveField('height')}
								disabled={isDoneLoading}
							/>
						</TreeFieldGroup>
					</TreePanelContent>
				) : null}
			</SidePanel>
			{/* <ConfirmationModal
				open={showConfirmClose}
				message="Are you sure you want to discard changes?"
				onConfirm={handleConfirmClose}
				onCancel={() => setShowConfirmClose(false)}
			/> */}
			{/* <ConfirmationModal
				open={showConfirmDelete}
				message="Are you sure you want to delete this flatten area?"
				onConfirm={confirmDelete}
				onCancel={() => setShowConfirmDelete(false)}
			/> */}
		</>
	);
}